import { Grid, Skeleton } from '@mui/material';
import { Field, Form, Formik, FormikProps } from 'formik';
import React, { useRef } from 'react';
import { FormikKeyboardDatePicker } from 'src/common/components/formik';
import { WO2Modal } from 'src/common/components/Modal';
import { LoadingProgress } from 'src/common/store/types/loadingProgress';
import * as yup from 'yup';
import { GrandfatherTemplateRequest } from '../store';

export interface Props {
  model: GrandfatherTemplateRequest;
  onClose: () => void;
  onConfirm: (payload: GrandfatherTemplateRequest) => Promise<void>;
  confirmProgress: LoadingProgress;
}

export function GrandfatherTemplateDialog({ model, onClose, onConfirm, confirmProgress }: Props): JSX.Element {
  const formRef = useRef<FormikProps<GrandfatherTemplateRequest>>(null);

  const initialFormValues: GrandfatherTemplateRequest = { ...model };

  return (
    <WO2Modal
      MuiDialogProps={{
        open: true,
        onClose: () => {
          onClose();
        },
        maxWidth: 'md',
      }}
      title={<>Close template</>}
      actions={[
        {
          label: 'Cancel',
          onClickHandler: () => {
            onClose();
          },
          type: 'outlined',
          disabled: false,
        },
        {
          label: 'Confirm',
          onClickHandler: () => {
            formRef.current?.submitForm();
          },
          type: 'contained',
          disabled: confirmProgress.isLoading,
          buttonType: 'submit',
        },
      ]}
    >
      <>
        {confirmProgress.isLoading && (
          <>
            <Skeleton variant="rectangular" width="100%" height={50} style={{ marginTop: '30px' }} />
            <Skeleton variant="rectangular" width="100%" height={118} style={{ marginTop: '10px' }} />
          </>
        )}
        {!confirmProgress.isLoading && (
          <>
            <Formik<GrandfatherTemplateRequest>
              innerRef={formRef}
              enableReinitialize={true}
              initialValues={initialFormValues}
              onSubmit={(values: GrandfatherTemplateRequest) => {
                onConfirm(values).then(() => {
                  onClose();
                });
              }}
              validationSchema={yup.object({
                grandfatherDate: yup.date().required('Close date is required').typeError("Close date must be in form of DD/MM/YYYY")
              })}
            >
              {() => (
                <Form>
                  <fieldset style={{ border: 'none', padding: '0', paddingTop: '20px' }}>
                    <Grid container justifyContent="flex-start" spacing={2}>
                      <Grid item xs={12}>
                        <Field
                          component={FormikKeyboardDatePicker}
                          name="grandfatherDate"
                          label="Closed from"
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </fieldset>
                </Form>
              )}
            </Formik>
            <p>When a template is closed, it cannot be applied to clients after the selected date, but will continue to be charged until the end of each client&apos;s consent period.</p>
          </>
        )}
      </>
    </WO2Modal>
  );
}
